import { BaseElement } from './base-element';
import { ConfirmOption } from './confirm';
import { ElementType } from './element-type';

export class Logout extends BaseElement {
  header: string | null = null;
  message: string | null = null;
  confirmOptions: ConfirmOption[] = [];

  constructor() {
    super();
    this.elementType = ElementType.logout;
  }
}
